import React from "react";

interface Option {
    label: string,
    value: any
}

const Select = (props: any) => {
    const {label, value, multiple, options, onChange, ...passedProps} = props;

    return (
        <div>
            <div className="text-white">{label}</div>
            <select {...passedProps} value={value} defaultValue={label} multiple={multiple}
                    onChange={(e) => onChange(e.target.value, value)}
                    className="bg-main-BG border-2 border-neutral-300 appearance-none rounded-md w-full text-gray-700 py-2 px-3 mb-3 mt-2 leading-tight">
                {options && options.map((option: Option, index: number) =>
                    (<option key={index} value={option.value}>{option.label}</option>)
                )}
            </select>
        </div>
    );
};

export default Select;
